<template>
  <div class="thumbs">
    <div class="question">{{ questionText }}</div>
    <div class="buttons-container" v-if="!rated">
      <div class="rate-button" @click="thumbsUp">👍</div>
      <div class="rate-button" @click="thumbsDown">👎</div>
    </div>
    <div v-else class="thanks-for-answering">
      <div class="thanks-title">תודה! 🙏</div>
      <div>התשובה שלך תעזור לנו להמשיך ולשפר את השירות</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Thumbs',
  data() {
    return {
      rated: false,
    };
  },
  props: {
    questionText: {
      type: String,
      required: true,
    },
  },
  methods: {
    thumbsUp() {
      this.$emit('thumbsup');
      this.rated = true;
    },
    thumbsDown() {
      this.$emit('thumbsdown');
      this.rated = true;
    },
  },
};
</script>

<style scoped lang="scss">

@import "~base-ui/src/scss/riseup-colors";

.thumbs {

  .question {
    margin-bottom: 16px;
  }

  .buttons-container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    .rate-button {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 82px;
      width: 46%;
      background-color: $riseup_light_blue;
      border-radius: 3px;
      cursor: pointer;
    }
  }

  .thanks-for-answering {
    padding: 17px;
    line-height: 1.5;
    border-radius: 5px;
    background-color: rgba($riseup_gray_0, 0.4);

    .thanks-title {
      margin-bottom: 3px;
      font-size: 20px;
      font-family: GretaSans;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/base-components/Thumbs.vue